import MenuPopover from "./MenuPopover.vue";
import { pluginify } from "./../../util";

pluginify(MenuPopover);

export default MenuPopover;

export { MenuPopover };
